import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import WorkflowChecklist, { type WorkflowCopy, type WorkflowOptions } from '@/frontend/features/Praxis/WorkflowChecklist'

export type WorkerWorkflowAccess = WorkflowOptions & { selected: string[]; copy: WorkflowCopy }
type Props = { workerId: string; access: WorkerWorkflowAccess; canManage: boolean }
export default function WorkerWorkflowPermissions({ workerId, access, canManage }: Props) {
  const form = useForm({ praxis_workflow_names: access.selected })
  return <form className="space-y-4 rounded-xl border border-border bg-card p-5" onSubmit={(event) => {
    event.preventDefault()
    form.patch(`/dashboard/digital_workers/${workerId}`, { preserveScroll: true })
  }}>
    <header><h2 className="text-sm font-semibold">{access.copy.title}</h2><p className="mt-1 text-sm text-muted-foreground">{access.copy.description}</p></header>
    <WorkflowChecklist options={access} selected={form.data.praxis_workflow_names} copy={access.copy} disabled={!canManage || form.processing}
      onChange={(names) => form.setData('praxis_workflow_names', names)} />
    {form.errors.praxis_workflow_names && <p role="alert" className="text-sm text-destructive">{form.errors.praxis_workflow_names}</p>}
    {canManage && <div className="flex justify-end"><Button type="submit" disabled={form.processing}>{form.processing ? access.copy.saving : access.copy.save}</Button></div>}
  </form>
}
